import { DEMO_IDENTITY } from '../lib/demoBackend.js';
import { useAuthStore } from '../stores/authStore.js';

export const isDemoMode = import.meta.env['VITE_DEMO_MODE'] === '1';

export const bootstrapDemoIdentity = (): void => {
  if (!isDemoMode) return;
  const store = useAuthStore.getState();
  if (store.accessToken && store.user?.id === DEMO_IDENTITY.user.id) return;
  store.setIdentity(DEMO_IDENTITY.user, DEMO_IDENTITY.accessToken, DEMO_IDENTITY.refreshToken);
};
